module.exports = __webpack_public_path__ + "img/rainbow.6e52d3aa.png";